import { fetchServerData } from '@shared/utils/fetchServerData/fetchServerData';

import { CartProductList } from '../../';

export const getCartProducts = async (cookie: string) => {
  return await fetchServerData<CartProductList>('cart?with-props', { headers: { cookie } });
};
